import DiscountBreakdownQueries from './DiscountBreakdownQueries'

const orderTransactionsDiscount = {
  orderTransactionsDiscount: {
    ...DiscountBreakdownQueries
  }
}

export default orderTransactionsDiscount